<template>
   
    <sweet-modal :id='configs.id' :title="title" v-on:close="closeHandler"
    :blocking="configs.blockBlur" overlay-theme="light" modal-theme="light" :ref="uuid">
        <div class="slot-content">
            <slot></slot>
        </div>
        <div class="panel-footer" v-if="configs.showConfirmButton || configs.showCancelButton">
            <button v-if="configs.showCancelButton" class="btn btn-danger" @click.prevent="cancel">{{configs.cancelText}}</button>
            <button v-if="configs.showConfirmButton" class="btn btn-primary-default" @click.prevent="confirm">{{configs.confirmText}}</button>
        </div>
    </sweet-modal>

</template>
<script>

import { SweetModal } from "sweet-modal-vue";
import { toggleVisibility } from './toggleVisibilityMixin.js';

export default {
    props: {
        options: Object,
        title: String,
        closeModal: {
            type: Function,
            default() {
                return null;
            }
        }
    },
    components: {
        SweetModal
    },
    mixins: [toggleVisibility],
    mounted: function(){
        if(this.options){
            this.overrideOptions();
        }
        var vm = this;
        this.$nextTick(function(){
            this.$emit("API", { open: this.$refs[this.uuid].open, close: this.$refs[this.uuid].close })
        });
    },
    data: function() {
        var vm = this;
        return {
            configs: {
                title: 'Header',
                subtitle: '',
                blockBlur: false,
                //setting default options
                showConfirmButton: true,
                showCancelButton: false,
                confirmText: vm.$Jed.firstUpperTranslate('confirm', null),
                cancelText: vm.$Jed.firstUpperTranslate('cancel', null),
                onConfirm: function(){
                    console.log("OK");
                },
                onCancel: function(){
                    console.log("DELETE")
                },
                closeAfterConfirm: true,
                closeAfterCancel: true
            }
        }
    },
    methods: {
        overrideOptions: function(){
            for(var prop in this.options){
                this.configs[prop] = this.options[prop]
            }
            // console.log(this.configs)
        },
        cancel: function(e){
            if(this.configs.onCancel) this.configs.onCancel();
            if(this.configs.closeAfterCancel) this.close();
        },
        confirm: function(e){
            if(this.configs.onConfirm) this.configs.onConfirm();
            if(this.configs.closeAfterConfirm) this.close();
        },
        closeHandler: function(){ //alla chiusura del modal, chiamo closeHandler, che chiama il metodo closeModal passato dal padre
            this.closeModal();
        }
    }
}
</script>

<style>
.sweet-modal-overlay {
    z-index: 9999
}
div.theme-light div.sweet-title {
    color: white; 
    background-color: #3c8dbc;
}
</style>


<style scoped>
.panel-footer {
    text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/dynamic/modalWrapper/SingleModal.vue?15b7a7e6